import React from 'react';
import { Check } from 'lucide-react';

export const ApplicationProgressBar = ({ step }) => (
  <div className="fixed top-20 left-0 w-full h-1 bg-zinc-900">
    <div
      className="h-full bg-orange-500 transition-all duration-500 ease-out"
      style={{ width: `${(step / 6) * 100}%` }}
    ></div>
  </div>
);

export const ApplicationIntro = ({ onNext }) => (
  <div className="text-center">
    <div className="inline-block px-3 py-1 mb-8 border border-zinc-800 rounded-full text-zinc-500 font-mono text-xs uppercase tracking-widest">Application Protocol</div>
    <h1 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight">Build companies that <br /> <span className="text-orange-500">break the screen.</span></h1>
    <p className="text-xl text-zinc-400 mb-12 leading-relaxed">You bring the obsession. We bring the capital, the team, and the playbook. <br /><span className="text-zinc-600 text-base mt-4 block font-mono">Takes 7 minutes. Be honest. Be brief.</span></p>
    <button
      onClick={onNext}
      className="bg-white text-zinc-950 px-10 py-4 font-bold uppercase tracking-wider hover:bg-orange-500 hover:text-white transition-all text-lg"
    >
      Start Application
    </button>
  </div>
);

export const ApplicationSuccess = ({ onHome }) => (
  <div className="text-center">
    <div className="w-20 h-20 border-2 border-emerald-500 rounded-full flex items-center justify-center mx-auto mb-8 text-emerald-500">
      <Check size={40} />
    </div>
    <h2 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight">Transmission Received.</h2>
    <p className="text-xl text-zinc-400 mb-12 leading-relaxed max-w-lg mx-auto">We review applications on rolling Fridays. If you're the anomaly we're looking for, we'll reach out.</p>
    <button
      onClick={onHome}
      className="text-zinc-500 hover:text-white border-b border-zinc-700 hover:border-white pb-1 transition-colors uppercase text-xs font-bold tracking-widest"
    >
      Return Home
    </button>
  </div>
);

export const ApplicationError = ({ onRetry, error }) => (
  <div className="text-center">
    <div className="w-20 h-20 border-2 border-red-500 rounded-full flex items-center justify-center mx-auto mb-8 text-red-500">
      <span className="text-4xl">✕</span>
    </div>
    <h2 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight">Submission Failed</h2>
    <p className="text-xl text-zinc-400 mb-4 leading-relaxed max-w-lg mx-auto">
      {error || 'Something went wrong. Please try again.'}
    </p>
    <button
      onClick={onRetry}
      className="mt-8 bg-white text-zinc-950 px-8 py-3 font-bold uppercase tracking-wider hover:bg-orange-500 hover:text-white transition-all"
    >
      Try Again
    </button>
  </div>
);

export const DisqualificationView = () => (
  <div className="text-center">
    <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tight">Not a fit. 🤝</h2>
    <p className="text-xl text-zinc-400 mb-12 leading-relaxed max-w-lg mx-auto">
      We're building for those who believe technology should enhance—not replace—human connection. That's not you, and that's okay.
    </p>
    <p className="text-zinc-600 text-sm font-mono">
      We wish you the best in your journey.
    </p>
  </div>
);
